module.exports = __webpack_public_path__ + "65619d923f51e0f31470436b5a0931c4.MP3";